<template>
  <div class="presupuesto-interno-facturacion">

    <b-card class="presupuesto-totales">
      <template slot="header">
        Facturación Estimada
        <template v-if="showFacturacion">
          <i class="fa fa-plus add-facturacion"
              @click.prevent="addFacturacion">
            <span >Agregar Fecha de Facturación</span>
          </i>
        </template>
      </template> 
  
      <b-btn class="btn-collapse-card" 
          variant="primary" 
          size="sm"
          @click.prevent="showFacturacion= !showFacturacion">
        <i :class="showFacturacion ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="totales" class="mt-2" v-model="showFacturacion">
        <form>
          <b-row>
            <b-col cols="12" md="12">
              <b-table hover
                  responsive="sm" 
                  class="registro"
                  :items="facturacion" 
                  :fields="fields">
                <div slot="table-busy" class="text-center">
                  <b-spinner class="table-spinner" label="Spinning" />
                </div>
                <template v-slot:cell(fechaFacturacion)="data">
                  {{ data.item.fechaFacturacion | fecha }}
                </template>
                <template v-slot:cell(importeFacturacion)="data">
                  {{ data.item.importeFacturacion | moneda }}
                </template>
                <template v-slot:cell(opciones)="data">
                  <b-dropdown variant="link" 
                      toggle-class="text-decoration-none" 
                      no-caret>
                    <template slot="button-content">
                      <i class="fa fa-ellipsis-v"></i>
                    </template>
  
                    <b-dropdown-item 
                        @click.stop="editFacturacion(data.item)">
                      <i class="fa fa-edit"></i>Editar Fecha</b-dropdown-item>
                    <b-dropdown-item 
                        @click.stop="removeFacturacion(data.item)">
                      <i class="fa fa-remove"></i>Eliminar Fecha</b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <small>Importe con fee, sin reembolsos ni financiación</small>  
            </b-col> 
          </b-row>
        </form>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'presupuestointerno/getField',
  mutationType: 'presupuestointerno/updateField',
});

export default {
  name: 'FacturacionABM',
  data () {
    return {
      fields: [
        {
          key: 'fechaFacturacion',
          label: 'Fecha',
        },
        {
          key: 'importeFacturacion',
          label: 'Importe',
          class: 'text-right'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      showFacturacion: false
    }
  },
  computed: {
    ...mapFields([
      'facturacion',
    ]),
  },  
  created() {
  },
  methods: {
    addFacturacion() {
      this.$emit('addFechaFacturacion');
    },
    editFacturacion(item) {
      this.$emit('editFechaFacturacion', item);
    },
    removeFacturacion(item) {
      this.$emit('removeFechaFacturacion', item);
    },
  },
}
</script>

<style>
  .presupuesto-interno-facturacion .card-header i.add-facturacion {
    position: relative;
    color: rgba(32, 168, 216, 0.5);
    cursor: pointer;
    margin-left: 12px;
    top: 2px; 
  }
  .presupuesto-interno-facturacion .card-header i.add-facturacion:hover {
    color: #20a8d8;
  }
  .presupuesto-interno-facturacion .card-header span {
    font-size: 11px;
    font-weight: 600;
    font-style: italic;
    top: -2px;
    position: relative;
    color: rgba(32, 168, 216, 0.5);
    margin-left: 5px;
  }
  .presupuesto-interno-facturacion .card-header i.add-facturacion:hover span{
    color: #20a8d8;
  }
  .presupuesto-interno-facturacion table thead th {
    border-top: none;
  }
  .presupuesto-interno-facturacion .registro table td[aria-colindex="1"] {
    width: calc(80% - 45px);
  }
  .presupuesto-interno-facturacion .registro table td[aria-colindex="2"] {
    width: 20%;
  }
  .presupuesto-interno-facturacion .registro table td[aria-colindex="3"] {
    width: 45px;
  }
</style>
